import classNames from 'classnames';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { State } from '~/types';
import capitalize from '~/utils/string';

export interface StatusBadgeProps {
  status: string;
  state: State;
  count?: number;
  className?: string;
  children?: ReactNode;
}

const STATE_ROOT_STYLE_MAP = {
  [State.Default]: 'border-info',
  [State.Info]: 'border-state-info',
  [State.Warning]: 'border-warning',
  [State.Danger]: 'border-danger',
  [State.Success]: 'border-success',
  [State.Tbd]: 'border-state-tbd',
};

const STATE_STATUS_STYLE_MAP = {
  [State.Default]: 'bg-info',
  [State.Info]: 'bg-state-info',
  [State.Warning]: 'bg-warning',
  [State.Danger]: 'bg-danger',
  [State.Success]: 'bg-success',
  [State.Tbd]: 'bg-state-tbd',
};

const STATE_BADGE_STYLE_MAP = {
  [State.Default]: 'text-info',
  [State.Info]: 'text-state-info',
  [State.Warning]: 'text-warning',
  [State.Danger]: 'text-danger',
  [State.Success]: 'text-success',
  [State.Tbd]: 'text-state-tbd',
};

const StatusBadge = ({
  status,
  count,
  state = State.Default,
  className,
  children,
}: StatusBadgeProps) => {
  const { t } = useTranslation();
  const stateRootStyles = STATE_ROOT_STYLE_MAP[state];
  const stateStatusStyles = STATE_STATUS_STYLE_MAP[state];
  const stateBadgeStyles = STATE_BADGE_STYLE_MAP[state];

  return (
    <div className={classNames('w-full mx-auto', className)}>
      <div
        className={classNames(
          stateRootStyles,
          stateStatusStyles,
          `border-solid text-xs border rounded flex my-1 min-w-min text-center font-semibold`,
        )}
      >
        {count !== undefined && (
          <div
            className={classNames(
              stateBadgeStyles,
              'bg-white items-center w-12 py-1 rounded-[3px] rounded-r-none',
            )}
          >
            {count > 999 ? '+999' : count}
          </div>
        )}
        <div
          className={classNames(
            'text-white w-full px-1 py-1 rounded-l-none whitespace-nowrap flex items-center justify-center',
          )}
        >
          {children}
          {capitalize(t(status))}
        </div>
      </div>
    </div>
  );
};

export default StatusBadge;
